/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useMemo, useState} from 'react'
import {useCommerceAPI} from '../contexts'

const useEinstein = () => {
    const api = useCommerceAPI()
    const [state, setState] = useState({loading: false, recommendations: []})

    // memoize the methods that don't rely on state so they don't change when state changes
    const ctx = useMemo(
        () => ({
            api: api.einstein,

            async sendViewProduct(...args) {
                return api.einstein.sendViewProduct(...args)
            },
            async sendViewSearch(...args) {
                return api.einstein.sendViewSearch(...args)
            },
            async sendClickSearch(...args) {
                return api.einstein.sendClickSearch(...args)
            },
            async sendViewCategory(...args) {
                return api.einstein.sendViewCategory(...args)
            },
            async sendClickCategory(...args) {
                return api.einstein.sendClickCategory(...args)
            },
            async sendViewPage(...args) {
                return api.einstein.sendViewPage(...args)
            },
            async sendBeginCheckout(...args) {
                return api.einstein.sendBeginCheckout(...args)
            },
            async sendCheckoutStep(...args) {
                return api.einstein.sendCheckoutStep(...args)
            },
            async sendViewReco(...args) {
                return api.einstein.sendViewReco(...args)
            },
            async sendClickReco(...args) {
                return api.einstein.sendClickReco(...args)
            },
            async sendAddToCart(...args) {
                return api.einstein.sendAddToCart(...args)
            },
            async getRecommenders(...args) {
                return api.einstein.getRecommenders(...args)
            },
            /**
             * @deprecated useRecommendations() instead
             *
             * Note: Renamed from pwa original to prevent accidental usage of this method
             */
            async getRawRecommendations(recommender, products) {
                const filteredProducts = products?.filter(
                    (product) => product?.productId || product?.id
                )

                if (Array.isArray(filteredProducts) && filteredProducts.length === 0) return

                setState((s) => ({...s, loading: true}))
                const recommendations = await api.einstein.getRawRecommendations(
                    recommender,
                    filteredProducts
                )
                setState({loading: false, recommendations})
            },
            /**
             * @deprecated useRecommendations() instead
             *
             * Note: Renamed from pwa original to prevent accidental usage of this method
             */
            async getRawZoneRecommendations(...args) {
                setState((s) => ({...s, loading: true}))
                const recommendations = await api.einstein.getRawZoneRecommendations(...args)
                setState({loading: false, recommendations})
            }
        }),
        [api.einstein]
    )

    return useMemo(
        () => ({
            ...state,
            ...ctx
        }),
        [ctx, state]
    )
}

export default useEinstein
